import React, { useState, useEffect } from 'react';
import api from '../api/axios';
import { 
  Building2, 
  Users, 
  Crown, 
  ChevronLeft,
  Loader2,
  Plus, 
  QrCode,    // <-- به ایمپورت اصلی اضافه شد
  Download,
  X
} from 'lucide-react';
import './SuperAdminCreateSalon.css';


export default function SuperAdminSalons() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const initialSalonState = {
    name: '',
    slug: '',
    phone: '',
    address: '',
    instagram: '',
    description: '',
    is_active: true
  };
  const [newSalon, setNewSalon] = useState(initialSalonState);
  const [files, setFiles] = useState({
    logo: null,
    cover_image: null
  });

  const [salons, setSalons] = useState([]);
  const [selectedSalon, setSelectedSalon] = useState(null);
  const [staffList, setStaffList] = useState([]);
  const [loadingSalons, setLoadingSalons] = useState(true);
  const [loadingStaff, setLoadingStaff] = useState(false);
  const [actionLoading, setActionLoading] = useState(null);
  const [createLoading, setCreateLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });
  const [showQrModal, setShowQrModal] = useState(false);


  // ۱. دریافت لیست سالن‌ها
  useEffect(() => {
    fetchSalons();
  }, []);

  const fetchSalons = async () => {
    try {
      setLoadingSalons(true);
      const res = await api.get('/salons');
      const data = res.data.data || res.data;
      setSalons(Array.isArray(data) ? data : []);
      if (Array.isArray(data) && data.length > 0) {
        handleSelectSalon(data[0]);
      }
    } catch (err) {
      setMessage({ text: 'خطا در دریافت لیست سالن‌ها', type: 'error' });
    } finally {
      setLoadingSalons(false);
    }
  };

  // ۲. انتخاب سالن و لود پرسنل
  const handleSelectSalon = async (salon) => {
    setSelectedSalon(salon);
    setLoadingStaff(true);
    try {
      const res = await api.get(`/admin/salons/${salon.slug}/staff`);
      setStaffList(res.data.data || []);
    } catch (err) {
      setMessage({ text: 'خطا در دریافت اطلاعات پرسنل', type: 'error' });
    } finally {
      setLoadingStaff(false);
    }
  };

  // ۳. ارتقای پرسنل به مدیر
  const handleMakeManager = async (staffId) => {
    if (!window.confirm('آیا مطمئن هستید که می‌خواهید این پرسنل به عنوان مدیر سالن منصوب شود؟')) return;
    
    setActionLoading(staffId);
    try {
      await api.put(`/admin/salons/${selectedSalon.slug}/staff/${staffId}/role`, {
        role: 'manager'
      });
      setMessage({ text: 'مدیر سالن با موفقیت تعیین شد.', type: 'success' });
      handleSelectSalon(selectedSalon);
    } catch (err) {
      setMessage({ text: err.response?.data?.message || 'خطا در ارتقای پرسنل', type: 'error' });
    } finally {
      setActionLoading(null);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewSalon((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleFileChange = (e) => {
    const { name, files: selectedFiles } = e.target;
    setFiles((prev) => ({
      ...prev,
      [name]: selectedFiles[0] || null
    }));
  };

  const handleCreateSalon = async (e) => {
    e.preventDefault();
    setCreateLoading(true);
    setMessage({ text: '', type: '' });

    try {
      const formData = new FormData();

      // نام الزامی است
      formData.append('name', newSalon.name.trim());

      // ارسال فیلدهای اختیاری فقط در صورت پر بودن تا ارور اعتبارسنجی نخورد
      if (newSalon.slug && newSalon.slug.trim() !== '') {
        formData.append('slug', newSalon.slug.trim());
      }
      if (newSalon.phone && newSalon.phone.trim() !== '') {
        formData.append('phone', newSalon.phone.trim());
      }
      if (newSalon.instagram && newSalon.instagram.trim() !== '') {
        formData.append('instagram', newSalon.instagram.trim());
      }
      if (newSalon.address && newSalon.address.trim() !== '') {
        formData.append('address', newSalon.address.trim());
      }
      if (newSalon.description && newSalon.description.trim() !== '') {
        formData.append('description', newSalon.description.trim());
      }

      // وضعیت بولین به صورت عددی ۱ یا ۰
      formData.append('is_active', newSalon.is_active ? '1' : '0');

      if (files.logo) {
        formData.append('logo', files.logo);
      }
      if (files.cover_image) {
        formData.append('cover_image', files.cover_image);
      }

      await api.post('/salons', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setMessage({ text: 'سالن با موفقیت ایجاد شد.', type: 'success' });
      setIsModalOpen(false);
      setNewSalon(initialSalonState);
      setFiles({ logo: null, cover_image: null });
      fetchSalons();
    } catch (err) {
      if (err.response?.status === 422 && err.response?.data?.errors) {
        const firstKey = Object.keys(err.response.data.errors)[0];
        const errorDetail = err.response.data.errors[firstKey][0];
        setMessage({ text: `خطای اعتبارسنجی: ${errorDetail}`, type: 'error' });
      } else {
        const errorMsg = err.response?.data?.message || 'خطا در ایجاد سالن.';
        setMessage({ text: errorMsg, type: 'error' });
      }
    } finally {
      setCreateLoading(false);
    }
  };

  const getqrCode = (e) => {
    console.log(e)
    // const res = await api.get(`/salons/${salon.slug}/qrcode`);
  }

  return (
    <div className="super-admin-container">
      {/* هدر صفحه */}
      <header className="super-admin-header">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <div>
            <h2>مدیریت سالن‌ها</h2>
            <p>لیست سالن‌ها و انتصاب مدیران</p>
          </div>
          <button className="btn-add-salon" onClick={() => setIsModalOpen(true)}>
            <Plus size={18} /> ایجاد سالن جدید
          </button>
        </div>
      </header>

      {/* پیام سیستم */}
      {message.text && (
        <div className={`admin-alert ${message.type === 'error' ? 'alert-danger' : 'alert-success'}`}>
          {message.text}
        </div>
      )}

      {/* مدال ایجاد سالن جدید */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="admin-panel-card modal-content" style={{ maxWidth: '650px', width: '95%', maxHeight: '90vh', overflowY: 'auto' }}>
            <div className="panel-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3>ایجاد سالن جدید</h3>
              <button 
                type="button" 
                onClick={() => setIsModalOpen(false)} 
                style={{ background: 'transparent', border: 'none', color: '#9ca3af', cursor: 'pointer' }}
              >
                <X size={20} />
              </button>
            </div>
            
            <form onSubmit={handleCreateSalon} className="admin-login-form" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginTop: '15px' }}>
              {/* نام سالن */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <label style={{ fontSize: '13px', color: '#9ca3af' }}>نام سالن *</label>
                <input 
                  type="text" 
                  name="name" 
                  placeholder="مثال: سالن پیرایش کلاسیک" 
                  value={newSalon.name} 
                  onChange={handleInputChange} 
                  className="admin-input-control" 
                  required 
                />
              </div>

              {/* اسلاگ */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <label style={{ fontSize: '13px', color: '#9ca3af' }}>نامک (Slug) انگلیسی</label>
                <input 
                  type="text" 
                  name="slug" 
                  placeholder="classic-barber (حداقل ۳ کاراکتر)" 
                  value={newSalon.slug} 
                  onChange={handleInputChange} 
                  className="admin-input-control" 
                  dir="ltr" 
                />
              </div>

              {/* تلفن همراه */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <label style={{ fontSize: '13px', color: '#9ca3af' }}>شماره موبایل</label>
                <input 
                  type="text" 
                  name="phone" 
                  placeholder="مثال: 09123456789" 
                  value={newSalon.phone} 
                  onChange={handleInputChange} 
                  className="admin-input-control" 
                  dir="ltr" 
                />
              </div>

              {/* اینستاگرام */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <label style={{ fontSize: '13px', color: '#9ca3af' }}>آیدی اینستاگرام</label>
                <input 
                  type="text" 
                  name="instagram" 
                  placeholder="barbershop_page" 
                  value={newSalon.instagram} 
                  onChange={handleInputChange} 
                  className="admin-input-control" 
                  dir="ltr" 
                />
              </div>

              {/* لوگو */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <label style={{ fontSize: '13px', color: '#9ca3af' }}>تصویر لوگو (حداکثر ۲MB)</label>
                <input 
                  type="file" 
                  name="logo" 
                  accept="image/jpeg,image/png,image/webp,image/jpg" 
                  onChange={handleFileChange} 
                  className="admin-input-control" 
                />
              </div>

              {/* کاور */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <label style={{ fontSize: '13px', color: '#9ca3af' }}>تصویر کاور (حداکثر ۵MB)</label>
                <input 
                  type="file" 
                  name="cover_image" 
                  accept="image/jpeg,image/png,image/webp,image/jpg" 
                  onChange={handleFileChange} 
                  className="admin-input-control" 
                />
              </div>

              {/* آدرس */}
              <div style={{ gridColumn: 'span 2', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <label style={{ fontSize: '13px', color: '#9ca3af' }}>آدرس دقیق</label>
                <textarea 
                  name="address" 
                  rows="2" 
                  placeholder="آدرس پستی سالن..." 
                  value={newSalon.address} 
                  onChange={handleInputChange} 
                  className="admin-input-control" 
                />
              </div>

              {/* توضیحات */}
              <div style={{ gridColumn: 'span 2', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <label style={{ fontSize: '13px', color: '#9ca3af' }}>توضیحات و بیو</label>
                <textarea 
                  name="description" 
                  rows="3" 
                  placeholder="توضیحات درباره سالن و خدمات ارائه شده..." 
                  value={newSalon.description} 
                  onChange={handleInputChange} 
                  className="admin-input-control" 
                />
              </div>

              {/* وضعیت فعال بودن */}
              <div style={{ gridColumn: 'span 2', display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
                <input 
                  type="checkbox" 
                  id="is_active" 
                  name="is_active" 
                  checked={newSalon.is_active} 
                  onChange={handleInputChange} 
                />
                <label htmlFor="is_active" style={{ fontSize: '14px', color: '#e5e7eb', cursor: 'pointer' }}>
                  سالن بلافاصله فعال باشد
                </label>
              </div>

              {/* دکمه‌های فرم */}
              <div style={{ gridColumn: 'span 2', display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
                <button 
                  type="button" 
                  onClick={() => setIsModalOpen(false)} 
                  className="btn-cancel"
                >
                  انصراف
                </button>
                <button 
                  type="submit" 
                  disabled={createLoading} 
                  className="btn-submit"
                >
                  {createLoading ? <Loader2 size={16} className="spinner" /> : 'ایجاد سالن'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* پنل ۲ ستونه: لیست سالن‌ها و مدیریت پرسنل */}
      <div className="super-admin-grid">
        {/* ستون راست: لیست سالن‌ها */}
        <div className="admin-panel-card">
          <div className="panel-title">
            <Building2 size={20} className="accent-icon" />
            <h3>سالن‌های ثبت‌شده</h3>
          </div>

          {loadingSalons ? (
            <div className="loading-state"><Loader2 className="spinner" /> در حال بارگذاری سالن‌ها...</div>
          ) : salons.length === 0 ? (
            <div className="empty-state">هیچ سالنی یافت نشد.</div>
          ) : (
            <div className="salons-list">
              {salons.map((salon) => (
                <div
                  key={salon.id}
                  onClick={() => handleSelectSalon(salon)}
                  className={`salon-item-card ${selectedSalon?.slug === salon.slug ? 'active' : ''}`}
                >
                  <div className="salon-info">
                    <h4>{salon.name}</h4>
                    <span>{salon.slug}</span>
                  </div>
                  <ChevronLeft size={18} className="chevron" />
                </div>
              ))}
            </div>
          )}
        </div>

        {/* ستون چپ: مدیریت پرسنل سالن انتخاب‌شده */}
        <div className="admin-panel-card">
          <div className="panel-title">
            <Users size={20} className="accent-icon" />
            <h3>پرسنل سالن: {selectedSalon ? selectedSalon.name : '...'}</h3>
              <button 
                type="button" 
                className="btn-qr-action"
                onClick={() => setShowQrModal(true)}
                title="نمایش QR Code اختصاصی سالن"
              >
                <QrCode size={20} />
                <span>QR کد</span>
              </button>
          </div>



          {showQrModal && (
            <div className="modal-overlay" onClick={() => setShowQrModal(false)}>
              <div className="qr-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="qr-modal-header">
                  <h3>QR Code سالن {selectedSalon?.name}</h3>
                  <button 
                    className="qr-close-btn" 
                    onClick={() => setShowQrModal(false)}
                  >
                    <X size={20} />
                  </button>
                </div>

                <p className="qr-modal-desc">
                  مشتریان با اسکن این کد مستقیماً به صفحه نوبت‌دهی سالن شما هدایت می‌شوند.
                </p>

                {/* نمایش مستقیم خروجی SVG از بک‌اند */}
                <div className="qr-image-wrapper">
                  <img 
                    src={`https://backend.vaghtiar.ir/api/salons/${encodeURIComponent(selectedSalon.slug)}/qrcode`} 
                    alt={`QR Code ${selectedSalon.name}`} 
                    className="qr-img"
                  />
                </div>

                <div className="qr-modal-footer">
                  <a 
                    href={`https://backend.vaghtiar.ir/api/salons/${encodeURIComponent(selectedSalon.slug)}/qrcode`} 
                    download={`qrcode-${selectedSalon.slug}.svg`} 
                    className="btn-download-qr"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Download size={18} />
                    دانلود فایل QR Code
                  </a>
                </div>
              </div>
            </div>
          )}






          {loadingStaff ? (
            <div className="loading-state"><Loader2 className="spinner" /> در حال دریافت پرسنل...</div>
          ) : staffList.length === 0 ? (
            <div className="empty-state">هیچ پرسنلی در این سالن ثبت نشده است.</div>
          ) : (
            <div className="staff-table-wrapper">
              <table className="staff-admin-table">
                <thead>
                  <tr>
                    <th>نام کارمند</th>
                    <th>شماره تماس</th>
                    <th>نقش فعلی</th>
                    <th>عملیات</th>
                  </tr>
                </thead>
                <tbody>
                  {staffList.map((staff) => (
                    <tr key={staff.id} className={staff.role === 'manager' ? 'is-manager-row' : ''}>
                      <td>
                        <div className="staff-name-col">
                          <strong>{staff.name || 'بدون نام'}</strong>
                          {staff.role === 'manager' && (
                            <span className="badge-manager">
                              <Crown size={12} /> مدیر فعلی
                            </span>
                          )}
                        </div>
                      </td>
                      <td dir="ltr" className="phone-cell">{staff.phone}</td>
                      <td>
                        <span className={`role-tag ${staff.role}`}>
                          {staff.role === 'manager' ? 'مدیر' : staff.role === 'owner' ? 'مالک' : 'کارمند عادی'}
                        </span>
                      </td>
                      <td>
                        {staff.role !== 'manager' ? (
                          <button
                            onClick={() => handleMakeManager(staff.id)}
                            disabled={actionLoading === staff.id}
                            className="btn-promote"
                          >
                            {actionLoading === staff.id ? (
                              <Loader2 size={14} className="spinner" />
                            ) : (
                              <>
                                <Crown size={14} /> ارتقا به مدیر
                              </>
                            )}
                          </button>
                        ) : (
                          <span className="text-muted">مدیر سالن است</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
